import { render, staticRenderFns } from "./ImportContacts.vue?vue&type=template&id=00d52ee0&scoped=true&"
import script from "./ImportContacts.vue?vue&type=script&lang=js&"
export * from "./ImportContacts.vue?vue&type=script&lang=js&"
import style0 from "./ImportContacts.vue?vue&type=style&index=0&id=00d52ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d52ee0",
  null
  
)

export default component.exports